import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, Modal } from 'react-bootstrap';
import AreaN2DataService from "./services/arean2.service";
import { Navigate } from 'react-router-dom';

function NewAreaN2(props) { 
    const [showerror, setShowerror] = useState(false);
    const [showsuccess, setShowsuccess] = useState(false);
    const [errmessage, setErrmessage] = useState('');
    const [succmessage, setSuccmessage] = useState('');
    const [lgShow, setLgShow] = useState(false);

    const [arean1id, setarean1id] = useState(props.arean1id);

    const [nombrearean2, setnombrearean2] = useState('');
    const [descripcionarean2, setdescripcionarean2] = useState('');
    
    const handleClose = () => setLgShow(false);  
    const handleShow = () => {
        // It seems this avoids the states to have a value when the modals first opens..
        // I thought the initialization of the variables worked for that purpose..
        // But may be this is needed because of the modal.
        setShowerror(false);
        setShowsuccess(false);
        setnombrearean2('');
        setdescripcionarean2('');
        setLgShow(true);         
    }
        
    const onChangeNombreAreaN2 = (e) => {
        setnombrearean2(e.target.value);
      } 
    
    const onChangeDescripcionAreaN2 = (e) => {
        setdescripcionarean2(e.target.value);
    } 
    
    const handleValidations = (e) => {
        if (setnombrearean2.length == 0) {
            setErrmessage('Se requiere un nombre para el área N2.');
            setShowerror(true);
            return;
        }
        saveAreaN2();
    }   
      
    let saveAreaN2 = ()  =>{   
        var data = {
            nombrearea: nombrearean2,
            descripcionarea: descripcionarean2,
            arean1id: arean1id
        }    
        
        AreaN2DataService.create(data)
        .then(response => {
            setSuccmessage('Area N2 agregada exitosamente. Redirigiendo al área N1...');
            setShowsuccess(true);
            props.retrieveAreaN1(props.arean1id);
            setLgShow(false);
        })
        .catch(e => {
          console.log(e);
          setErrmessage(e.response?e.response.data.message:e.message);
          setShowerror(true);
          setSuccmessage('');
          setShowsuccess(false);
        })        
    }  

    return (
        <>         
            <Button lg={8} variant='secondary' onClick={handleShow}>Agregar área N2</Button>
            <Modal
                size="lg"
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    {'Agregar área N2'}
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row className='mb-2 d-flex'>
                            <Col className='col-md-3' md={4}>
                                <FormLabel className='mb-2'>Nombre área N2:</FormLabel>       
                                <FormControl style={{maxWidth:"300px"}} type="text" name="internalidentifier" id="internalidentifier" onChange={onChangeNombreAreaN2} ></FormControl>
                            </Col>

                            <Col md={8}>
                                <FormLabel className='mb-2'>Descripción área N2:</FormLabel>       
                                <FormControl type="text" name="sublocationdescription" id="sublocationdescription" onChange={onChangeDescripcionAreaN2} ></FormControl>
                            </Col>          

                        </Row>
                        {showerror && (
                        <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                            <Alert.Heading>Error</Alert.Heading>
                            <p>{errmessage}</p>
                        </Alert>      
                        )}
                        {showsuccess && (
                        <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                            <Alert.Heading>Done</Alert.Heading>
                            <p>{succmessage}</p>
                        </Alert>      
                        )}     
                        <hr></hr>
                        <Row className='mb-2'>
                            <Col className='col-md-4'>
                                <Button className='btn-secondary' id='saveSublocation' onClick={handleValidations}>Guardar área N2</Button>            
                            </Col>
                        </Row>          
                    </Container>    
                </Modal.Body>
            </Modal>
        </>
    );      
     
}

export default NewAreaN2;

{/*
const EditLocationsPage = (props) => {    



  
  return (
    <>
      <Container>
        <Row className='mb-4'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>EDIT LOCATION</h1>

        <Row className='mb-4'>
            <FormLabel>Sublocations</FormLabel>
            <Col className='mb-4 col-md-4'>
                <Button variant='primary' className='md-4'>Add Sublocation</Button>
            </Col>
            
            
            <SublocationsList listOfSublocations = {listOfSublocations}></SublocationsList>            
        </Row>
                                   
      </Container>    
    </>
  )

}

export default EditLocationsPage;

*/} 